export default "#define PRECISION 0.0001\r\n\r\nbool compareFloat(float floatOne, float floatTwo) {\r\n    return abs(floatOne - floatTwo) < PRECISION;\r\n}";